var exports = {
  "o": "x31de4314--4cbd18--underground-icon",
  "F": "x31de4314--4cbd18--underground-icon--regions",
};

module.exports = exports;
